import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import moment from "moment";
import Header from "../../../components/Header.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function () {
        return {
            pageTitle: "Liste des navires",
            date_arriver: moment().format('DD/MM/YYYY'),
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            element: {
                id_navire: '',
                date_arriver: '',
            },
            NAVIRE: [],
            vuetable: {
                moreParams: {},
                fields: [
                    {
                        name: 'transporteur',
                        title: 'Transporteur',
                        sortField: 'transporteur',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center',
                        width: "80px",
                        dataClass: "text-center"
                    }

                ],
                sortOrder: [
                    {field: 'transporteur', direction: 'asc'}
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: ' w-100  d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                },
            },
            motCle: "",
            crudform: {
                id: '',
                transporteur: '',
                etat_suppression_transporteur: '',
                element: [
                    {
                        id: '',
                        id_transporteur: '',
                        nom_chauffeur: '',
                        num_chauffeur: '',
                        num_camion: '',
                        num_remorque: '',
                        permis: '',
                    },
                ]
            },
            crudmodaltitle: "Nouveau Transporteur",
            crudSuivieEnlevement: [
                {id: '',
                    id_dossier: '',
                    date_enlevement: '',
                    date_enlevement_formatted: '',
                    ouverture_bl_numero: '',
                    date_arriver: '',
                    date_arriver_formatted: '',
                    id_navire: ''
                }
            ],
            btn_submit: false,
        }
    },
    methods: {



        spliceBL(index) {
            this.crudform.element.splice(index, 1);
        },
        pushBL() {
            this.crudform.element.push(
                {
                    id: '',
                    id_transporteur: '',
                    nom_chauffeur: '',
                    num_chauffeur: '',
                    num_camion: '',
                    num_remorque: '',
                    permis: '',
                },
            )
        },

        onRowClass(dataItem, index) {
            if (index == "") console.log("");

            if (Number(dataItem.solde) < 0) {
                // return 'text-danger text-bold';
            }
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {
            console.log(rowData.id)
            axios.get(this.BASE_URL + "/transporteur/get/"+rowData.id ).then(response => {
                this.crudform = response.data[0];
                this.openModal();
            });
            this.crudmodaltitle = "Editer le Transporteur";

        },

        deleteBL(bl, rowData) {
            let formulaire = new FormData();
            formulaire.append('numero_bl', bl);
            formulaire.append('nom_navire', rowData.nom_navire);
            formulaire.append('date_arriver', rowData.date_arriver);
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer ce BL?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {

                        axios.post(this.BASE_URL + "/navire/deletebl/", formulaire).then((response) => {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                this.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })
        },

        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {


                        axios.post(that.BASE_URL + "/transporteur/delete/"+rowData.id).then(function (response) {
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                });
                                Vue.nextTick(() => that.$refs.vuetable.refresh());

                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },
        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        setFilter() {
            this.vuetable.moreParams.filter = this.motCle;
            this.vuetable.moreParams.criteriacol = this.criteriacol;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {
            this.motCle = "";
            this.criteriacol = "";
            this.vuetable.moreParams.filter = this.motCle;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        openModal() {
            this.$bvModal.show("crudmodal");
        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },
        addRow() {
            this.crudmodaltitle = "Nouveau Transporteur";
            this.crudform= {
                id: '',
                    transporteur: '',
                    etat_suppression_transporteur: '',
                    element: [
                    {
                        id: '',
                        id_transporteur: '',
                        nom_chauffeur: '',
                        num_chauffeur: '',
                        num_camion: '',
                        num_remorque: '',
                        permis: '',
                    },
                ]
            };

            this.openModal();
        },
        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.crudform.id == '' ? that.BASE_URL + "/transporteur/addaction" : that.BASE_URL + "/transporteur/editaction";

                        axios.post(link, $("#formulaire").serialize()).then(function (response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },
        fetchData: function () {
            axios.get(this.BASE_URL + "/navire/getall").then(response => {
                this.NAVIRE = response.data;
            });
        },
        gotoDossier(bl, data) {
            let formulaire = new FormData();
            formulaire.append('num_bl', bl);
            formulaire.append('numero_navire', data.rowData.nom_navire);

            axios.post(this.BASE_URL + "/dossier/getinfobyblandnavire/", formulaire).then(response => {
                console.log(response.data);
                this.$router.push("/dossier/edit/" + response.data[0].id);
            })

            // this.$router.push("/dossier/edit/"+rowData.id);
        }
    },

    created: function () {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";

    },
    mounted: function () {

    }
}
